var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccessNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 0.666626C6.64033 0.666626 0.666992 6.63996 0.666992 14C0.666992 21.36 6.64033 27.3333 14.0003 27.3333C21.3603 27.3333 27.3337 21.36 27.3337 14C27.3337 6.63996 21.3603 0.666626 14.0003 0.666626ZM11.3337 20.6666L4.66699 14L6.54699 12.12L11.3337 16.8933L21.4537 6.77329L23.3337 8.66663L11.3337 20.6666Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessNotificationIcon);
export default __webpack_public_path__ + "static/media/success-notification-icon.3245c57a435902daa1e054eb24c8654a.svg";
export { ForwardRef as ReactComponent };